import React from "react";
import { 
  Box, 
  Card,
  CardContent,
  Skeleton,
  Grid
} from "@mui/material";

function BillingDashboardSkeleton() {
  return (
    <Box sx={{ minHeight: 400, p: 2 }}>
      {/* Header section */}
      <Box sx={{ mb: 4 }}>
        <Skeleton variant="text" width={250} height={36} sx={{ mb: 2 }} />
        <Skeleton variant="text" width={400} height={20} />
      </Box>

      {/* Subscription cards grid */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[1, 2, 3].map((item) => (
          <Grid item xs={12} md={4} key={item}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Skeleton variant="text" width={120} height={24} sx={{ mb: 2 }} />
                <Skeleton variant="text" width={80} height={32} sx={{ mb: 1 }} />
                <Skeleton variant="text" width={150} height={20} sx={{ mb: 2 }} />
                <Box sx={{ mt: 2 }}>
                  <Skeleton variant="rectangular" width={100} height={36} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Billing info section */}
      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Skeleton variant="text" width={180} height={28} sx={{ mb: 3 }} />
          
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Box sx={{ mb: 2 }}>
                <Skeleton variant="text" width={100} height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width={200} height={24} />
              </Box>
              <Box sx={{ mb: 2 }}>
                <Skeleton variant="text" width={120} height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width={150} height={24} />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ mb: 2 }}>
                <Skeleton variant="text" width={80} height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width={180} height={24} />
              </Box>
              <Box sx={{ mb: 2 }}>
                <Skeleton variant="text" width={140} height={20} sx={{ mb: 1 }} />
                <Skeleton variant="text" width={100} height={24} />
              </Box>
            </Grid>
          </Grid>

          {/* Action buttons */}
          <Box sx={{ 
            display: "flex", 
            gap: 2, 
            mt: 3,
            flexWrap: "wrap"
          }}>
            <Skeleton variant="rectangular" width={120} height={40} />
            <Skeleton variant="rectangular" width={150} height={40} />
            <Skeleton variant="rectangular" width={100} height={40} />
          </Box>
        </CardContent>
      </Card>

      {/* Payment history section */}
      <Card>
        <CardContent>
          <Skeleton variant="text" width={160} height={28} sx={{ mb: 3 }} />
          
          {/* Table header */}
          <Box sx={{ 
            display: "flex", 
            justifyContent: "space-between",
            mb: 2,
            pb: 1,
            borderBottom: 1,
            borderColor: "divider"
          }}>
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={100} height={20} />
            <Skeleton variant="text" width={80} height={20} />
            <Skeleton variant="text" width={60} height={20} />
          </Box>
          
          {/* Table rows */}
          {[1, 2, 3, 4].map((item) => (
            <Box key={item} sx={{ 
              display: "flex", 
              justifyContent: "space-between",
              mb: 2,
              py: 1
            }}>
              <Skeleton variant="text" width={100} height={20} />
              <Skeleton variant="text" width={120} height={20} />
              <Skeleton variant="text" width={70} height={20} />
              <Skeleton variant="rectangular" width={80} height={20} />
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  );
}

export default BillingDashboardSkeleton;